export enum NotificationSubjectEnum {
  TASK = 'TASK',
  DEAL = 'DEAL',
  DEALS_GROUP = 'DEALS_GROUP',
  REFERENCE = 'REFERENCE',
  PROJECT = 'PROJECT',
  HD_TASK = 'HD_TASK',
  MAILING = 'MAILING',
  MAILING_TEMPLATE = 'MAILING_TEMPLATE',
  BUDGET_REQUEST = 'BUDGET_REQUEST',
  PURCHASE = 'PURCHASE',
  CHANGELOG = 'CHANGELOG',
  CASH_GAP = 'CASH_GAP',
  TRANSIT_TASK = 'TRANSIT_TASK',
}
